module.exports = __webpack_public_path__ + "media/images/800x418-42a8d895250e11598dfd0f1362df4b8d.png";